export default class DropHintCtrl {
    constructor ($scope, $http, $rootScope, $compile) {
    'ngInject';
        $scope.drophintfrm = {
            sent: false
        };
        
        $scope.product={};
        $scope.validationOptions = {
            rules: {
                'your-name': {
                    required: true,
                },
                'friends-email': {
                    required: true,
                    email: true
                },
                'friends-name': {
                    required: true,
                }
            },
            messages: {
                'your-name':{
                    required: 'Required'
                },
                'friends-email':{
                    required: 'Required'
                },
                'friends-name':{
                    required: 'Required'
                },
            },
            ignore: [],
            errorPlacement: function (error, element) {
                if ($(element).is(":radio")) {
                    var hidELement = $(element).parent().parent().parent();
                    error.appendTo(hidELement);

                } else if ($(element).is("select")) {

                    var hidELement = $(element).parent().find('span.select2.select2-container');
                    error.insertAfter(hidELement);

                } else if ($(element).is(":hidden")) {
                    var hidELement = $(element).parent();
                    error.insertAfter(hidELement);
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .addClass(errorClass)
                        .removeClass(validClass);
                } else {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);

                    $(element)
                        .prev()
                        .addClass('top-error');

                    $(element)
                        .parent()
                        .addClass('error')
                }
            },
            unhighlight: function (element, errorClass, validClass) {

                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .removeClass(errorClass)
                        .addClass(validClass);
                } else {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);

                    $(element)
                        .prev()
                        .removeClass('top-error');

                    $(element)
                        .parent()
                        .removeClass('error')
                }
            }
        };
        $scope.dh = {};
        $scope.dh.name          = '';
        $scope.dh.friends_email = '';
        $scope.dh.friends_name  = '';
        $scope.drophint = function(_url){
            if ($scope.DropHintForm.validate()) {
                $scope.drophintfrm.sent = true;
                $http({
                    method: "POST",
                    url: _url,
                    data: $rootScope.params($scope.dh),
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                }).then(function success(successData) {
                    var data = successData.data;
                    $scope.drophintfrm.sent = true;
                    if (data.status) {
                        
                    }
                }, function error(errorData) {
                    console.log('Error: ', errorData)
                });
            }
            
        }
    }
}